/*/
 * Swiper v8
/*/
	import Swiper, { Mousewheel, Navigation, Pagination } from 'swiper';

	// home
	// const siteSwiperHome = new Swiper('[site-swiper-home]', {
	// 	modules: [Navigation, Pagination, Scrollbar],
	// 	loop: true,
	// 	speed: 500,
	// 	threshold: 5,
	// 	autoHeight: false,
	// 	centeredSlides: true,
	// 	centerInsufficientSlides: true,
	// 	grabCursor: true,
	// 	pagination: {
	// 		el: '.swiper-pagination',
	// 		clickable: true
	// 	},
	// 	navigation: {
	// 		nextEl: '.swiper-button-next',
	// 		prevEl: '.swiper-button-prev',
	// 	},
	// 	scrollbar: {
	// 		el: '.swiper-scrollbar',
	// 	},
	// })

	// Blog - Categories
	const siteSwiperHome = new Swiper('[site-swiper-categories]', {
		modules: [Mousewheel],
		slidesPerView: 'auto',
		loop: false,
		speed: 500,
		threshold: 5,
		autoHeight: false,
		grabCursor: true,
	})

	// Blog - Gallery
	const sitePostGalleries = document.querySelectorAll('[site-swiper-post]')

	if (sitePostGalleries.length > 0) {
		sitePostGalleries.forEach(e => {
			const prevEl = document.querySelector(e.dataset.prev)
			const nextEl = document.querySelector(e.dataset.next)
			const paginationEl = document.querySelector(e.dataset.pagination)
			const singleImage = e.querySelectorAll('.swiper-slide').length == 1

			console.log(singleImage)

			const swiper = new Swiper(e, {
				modules: [Navigation, Pagination],
				loop: singleImage ? false : true,
				speed: 500,
				threshold: 5,
				autoHeight: true,
				grabCursor: true,
				watchOverflow: true,
				observer: true,
				navigation: {
					nextEl: nextEl,
					prevEl: prevEl,
					lockClass: 'd-none'
				},
				pagination: {
					el: paginationEl,
					lockClass: 'd-none',
					clickable: true
				}
			})
		})
	}


